import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { NoticeLogOutput, NoticesLogService } from 'core/http/project/notices-log/notices-log.service';
import { Observable } from 'rxjs';

@Injectable()
export class NoticeInfoResolver {
  constructor(private noticesLogService: NoticesLogService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<NoticeLogOutput> {
    const noticeId = route.params.noticeId;

    return this.noticesLogService.getNotice(noticeId);
  }
}
